/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:19:19
 * @LastEditTime: 2021-05-27 11:14:41
 */
// ==== loginStatus 登录态同步相关
import event from './event';
import cookie from './cookie';
import { isFunction, g } from './base';
import platform from './platform'; // 清qq域下的微信登录态，防止和老milo冲突

var clearWXInQQ = function clearWXInQQ() {
  var oCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['acctype', 'appid', 'access_token', 'openid'];

  for (var i = 0; i < oCookie.length; i++) {
    cookie.clear(oCookie[i], 'qq.com', '/');
  }
};

var loginStatus = {
  // 存储未执行的callback
  arrCallbacks: [],
  // 执行callback，解决并行callbck问题
  doCallback: function doCallback(service) {
    var self = this;

    for (var i = 0; i < self.arrCallbacks.length;) {
      var cbObj = self.arrCallbacks[i];

      if (service == cbObj.service) {
        var childWin = g("loginStatusSyncFrame_".concat(cbObj.service)).contentWindow || null;

        if (isFunction(cbObj.cb)) {
          cbObj.cb(childWin);
        }

        self.arrCallbacks.splice(i, 1);
      } else {
        i = i + 1;
        continue;
      }
    }
  },
  // iframe进度队列
  waitingQueue: {},
  // 标识是否初始化过onmessage
  isInitMessage: false,
  // 判断是否合法来源
  isLegalOrigin: function isLegalOrigin(url) {
    // 检测是否合法域名
    // 合法域名列表
    var whiteDomain = ['qq.com']; // 白名单

    var blackDomain = ['p.imtt.qq.com']; // 黑名单

    var isLegal = false;
    var regStr = '^(https\\:\\/\\/|http\\:\\/\\/|\\/\\/|)([0-9a-z-A-Z]+\\.)*reg(\\:[0-9]*){0,1}(\\/{1,2}.*){0,1}$';
    var regWhite = null; // 判断白名单

    for (var i = 0; i < whiteDomain.length; i++) {
      regWhite = new RegExp(regStr.replace('reg', whiteDomain[i].replace(/\./g, '\\.')));

      if (regWhite.test(url)) {
        isLegal = true;
      }
    }

    if (isLegal == false) {
      // 不在白名单
      return false;
    } // 判断黑名单


    var regBlack = null;

    for (var _i = 0; _i < blackDomain.length; _i++) {
      regBlack = new RegExp(regStr.replace('reg', blackDomain[_i].replace(/\./g, '\\.')));

      if (regBlack.test(url)) {
        isLegal = false;
      }
    }

    return isLegal;
  },
  // 初始化iFrame
  init: function init(service, url, callback) {
    var self = this;
    self.arrCallbacks.push({
      cb: callback,
      service: service
    });
    var asyncCookieFrame = document.getElementById("loginStatusSyncFrame_".concat(service));

    if (!window.miloWaitingQueue) {
      window.miloWaitingQueue = {};
    }

    if (asyncCookieFrame && '2' == asyncCookieFrame.getAttribute('miloloadstatus')) {
      // iframe已加载
      self.doCallback(service);
      return;
    }

    if (1 === window.miloWaitingQueue[service] || asyncCookieFrame) {
      // 正在创建iframe
      return;
    }

    window.miloWaitingQueue[service] = 1; // 等body的 DOM ready之后再进行下面操作，否则可能会无法访问

    event.ready(function () {
      var iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.id = "loginStatusSyncFrame_".concat(service);
      iframe.width = 0;
      iframe.height = 0;
      iframe.frameborder = 0;
      iframe.style.border = '0';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          window.miloWaitingQueue[service] = 0;
          iframe.setAttribute('miloloadstatus', '2');
          self.doCallback(service);
        });
      } else {
        iframe.onload = function () {
          window.miloWaitingQueue[service] = 0;
          iframe.setAttribute('miloloadstatus', '2');
          self.doCallback(service);
        };
      }
    });

    if (self.isInitMessage) {
      return;
    }

    if ('function' === typeof window.postMessage) {
      window.addEventListener('message', function (e) {
        // console.log(e.data);
        // 判断来源
        if (!self.isLegalOrigin(e.origin)) {
          // 来源非法
          return;
        }

        var eData = {};

        if (!e.data) {
          return;
        } // 增加不是合法json的try catch


        try {
          if ('string' === typeof e.data) {
            eData = JSON.parse(e.data);
          } else {
            eData = e.data;
          }

          if (eData && eData.callbackName && 'done' == eData.action) {
            var data = eData.data || '';
            isFunction(window[eData.callbackName]) && window[eData.callbackName](data);
          }
        } catch (e) {
          console.log(e);
        }
      }, false);
    }

    self.isInitMessage = true;
  },

  /**
   * 同步登录态到xx.qq.com
   * @param {domain} 域名
   * @param {oCookie} object 登录态对象{openid:"xxx",acctype:"xxx"}
   * @param {callback} 同步之后的回调函数
   */
  syncToQQ: function syncToQQ(domain, oCookie, callback) {
    // add by weiztang 目前wx也在当前域了，也需要这个能力
    if (!oCookie) {
      // 目前只支持qc登录态同步
      return;
    }

    var service = domain.split('.').join('_');
    this.init(service, "".concat(location.protocol, "//").concat(domain, "/comm-htdocs/login/asyncLoginStatus.html"), function () {
      var iframe = g("loginStatusSyncFrame_".concat(service));
      var newCookie = []; // add by isakkong 与milojs统一

      for (var k in oCookie) {
        // newCookie[k] = [oCookie[k], '/', 600];
        newCookie.push([encodeURIComponent(k), encodeURIComponent(oCookie[k]), encodeURIComponent('/'), 600].join('='));
      }

      if ('function' === typeof window.postMessage) {
        var callbackName = "syncToQQ_".concat(Math.ceil(100000 * Math.random()));

        window[callbackName] = function () {
          isFunction(callback) && callback();
        };

        iframe.contentWindow.postMessage("loginStatus|".concat(newCookie.join(','), "|").concat(callbackName), '*');
      }
    });
  },

  /**
   * 提交AME请求前，同步登录态
   * @param callback 登录态同步之后的回调
   */
  syncToAME: function syncToAME(callback) {
    // 目前用于wx、qc、ks与wegame登录态同步
    // 同步登录态之前，先清一遍旧的登录态
    var self = this;
    self.clearAME(function () {
      if ('qc' != cookie.get('acctype') && 'wg' != cookie.get('acctype') && 'ks' != cookie.get('acctype') && 'wx' != cookie.get('acctype') && 'mini' != cookie.get('acctype') && 'qqmini' != cookie.get('acctype')) {
        isFunction(callback) && callback();
        return;
      } // console.log('syncToAME', cookie.get('login_origin'));


      if ('wx' == cookie.get('acctype') && (cookie.get('login_origin') === 'ulink' || cookie.get('login_origin') === 'milo')) {
        // 带unlink标识则支持qq.com下的微信登录态
        console.log('syncToAMEreturn');
        isFunction(callback) && callback();
        return;
      }

      if ('wx' == cookie.get('acctype') && !platform.isWxApp() && platform.isMobile()) {
        // 移动端非微信客户端（其他APP），则支持qq.com下的微信登录态
        isFunction(callback) && callback();
        return;
      } // 回调函数


      var callbackName = "syncToAME_".concat(Math.ceil(100000 * Math.random()));

      window[callbackName] = function () {
        isFunction(callback) && callback();
      }; // cookie


      var oCookie = {
        acctype: cookie.get('acctype') || '',
        openid: cookie.get('openid') || '',
        access_token: cookie.get('access_token') || '',
        appid: cookie.get('appid') || '',
        refresh_token: cookie.get('refresh_token') || '',
        // wegame登录态用到
        ieg_ams_token: cookie.get('ieg_ams_token') || '',
        // 小程序透传
        ieg_ams_session_token: cookie.get('ieg_ams_session_token') || '',
        ieg_ams_token_time: cookie.get('ieg_ams_token_time') || ''
      };
      /*
            	QQ互联登录态改造期间，临时允许pt与qc共存，【PT下线后删除改逻辑】 -----Start-----
            */

      if ('qc' == cookie.get('acctype') && window.iUseQQConnect != 1) {
        oCookie = {
          acctype: '',
          openid: '',
          access_token: '',
          appid: ''
        };
      }
      /*
            	QQ互联登录态改造期间，临时允许pt与qc共存，【PT下线后删除改逻辑】 -----End-----
            */


      if ('function' !== typeof window.postMessage) {
        // 不支持postMessage
        var newCookie = {};

        for (var k in oCookie) {
          newCookie[k] = [oCookie[k], '/', 600];
        }

        self.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function (childWin) {
          childWin.syncCookie({
            action: 'ame',
            cookieObj: newCookie
          }, function () {
            isFunction(callback) && callback();
          });
        });
      } else {
        self.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function () {
          var iframe = g('loginStatusSyncFrame_ams_ame');
          var newCookie = {};

          for (var _k in oCookie) {
            newCookie[_k] = [oCookie[_k], '/', 600];
          }

          iframe.contentWindow.postMessage(JSON.stringify({
            action: 'ame',
            cookieObj: newCookie,
            callbackName: callbackName
          }), '*');
        });
      }
    });
  },

  /**
   * 清除game.qq.com上登录态
   * @param callback 登录态清除之后的回调
   * @param arrCookies 指定清除的cookie名
   */
  clearAME: function clearAME(callback, arrCookies) {
    var useWxInQQDomain = false; // 是否识别qq域名下的微信登录态

    var loginOrigin = cookie.get('login_origin'); // 当前域名登录态是由谁种的，（ulink兼容）
    // console.log('clearAme', loginOrigin);

    if (loginOrigin === 'ulink' || loginOrigin === 'milo' || !platform.isWxApp() && platform.isMobile()) {
      useWxInQQDomain = true;
    } // console.log('useWxInQQDomain', useWxInQQDomain);


    if (!useWxInQQDomain) {
      clearWXInQQ(); // 清qq.com域名下的微信登录态，防止和老milo业务登录态冲突
    } // 回调函数


    var callbackName = "syncToAME_".concat(Math.ceil(100000 * Math.random()));

    window[callbackName] = function () {
      isFunction(callback) && callback();
    }; // cookie


    var oCookie = {
      acctype: '',
      openid: '',
      access_token: '',
      appid: '',
      ieg_ams_token_time: '',
      ieg_ams_session_token: '',
      ieg_ams_token: ''
    }; // 指定清除的cookie

    if (arrCookies && arrCookies.length) {
      oCookie = {};

      for (var i = 0; i < arrCookies.length; i++) {
        oCookie[arrCookies[i]] = '';
      }
    }

    if ('function' !== typeof window.postMessage) {
      // 不支持postMessage
      var newCookie = {};

      for (var k in oCookie) {
        newCookie[k] = [oCookie[k], '/', -600];
      }

      this.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function (childWin) {
        childWin.syncCookie({
          action: 'onlygame',
          cookieObj: newCookie
        }, function () {
          isFunction(callback) && callback();
        });
      });
    } else {
      this.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function () {
        var iframe = g('loginStatusSyncFrame_ams_ame');
        var newCookie = {};

        for (var _k2 in oCookie) {
          newCookie[_k2] = [oCookie[_k2], '/', -600];
        }

        iframe.contentWindow.postMessage(JSON.stringify({
          action: 'onlygame',
          cookieObj: newCookie,
          callbackName: callbackName
        }), '*');
      });
    }
  }
};
export default loginStatus;